/**
 * Process guides published with the back office (apps/backoffice/public/docs) and served at the same origin, so officers can open
 * the description of the procedure they are running from the case itself. The concentration guide is rendered from
 * docs/ec-review-process.md.
 */
const PROCESS_GUIDES: Partial<Record<string, string>> = {
  EconomicConcentration: `${import.meta.env.BASE_URL}docs/ec-review-process.pdf`,
};

export function processGuideFor(caseType: string): string | undefined {
  return PROCESS_GUIDES[caseType];
}
